import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TeamsService, UserTeamMembership } from '../../../services/teams/teams.service';

export interface UserTeamMembershipsDialogData {
  user: any;
}

@Component({
    selector: 'app-user-team-memberships-dialog',
    templateUrl: './user-team-memberships-dialog.component.html',
    styleUrls: ['./user-team-memberships-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserTeamMembershipsDialogComponent implements OnInit {
  public memberships: UserTeamMembership[] = [];
  public loading = false;
  public errorMessage = '';
  public readonly columnsToDisplay = ['team', 'company'];

  constructor(
    public dialogRef: MatDialogRef<UserTeamMembershipsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserTeamMembershipsDialogData,
    private teamsService: TeamsService,
  ) {}

  ngOnInit(): void {
    this.loadMemberships();
  }

  async loadMemberships(): Promise<void> {
    this.loading = true;
    this.errorMessage = '';

    try {
      this.memberships = await this.teamsService.getUserTeamMemberships(this.data.user.id);
    } catch (error) {
      this.memberships = [];
      this.errorMessage = 'Unable to load team memberships for this user.';
    } finally {
      this.loading = false;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
